import axios from 'axios'
import router from '@/router'

// 可选：防止多次弹窗和跳转
let is401Handled = false

const request = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 10000
})

// 请求拦截器
request.interceptors.request.use((config) => {
  config.headers.token = localStorage.getItem("videotoken")
  return config
})

// 响应拦截器
request.interceptors.response.use(
  (res) => {
    return res;
  },
  (error) => {
    console.log(error)
    
    // 超时错误处理：仅在控制台输出111
    if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
      console.log('111'); // 仅输出111，不影响原有逻辑
      // 继续执行原有的错误处理
    }
    
    // 其他错误处理逻辑保持不变
    if (error.response) {
      switch (error.response.status) {
        case 401:
          if (!is401Handled) {
            is401Handled = true
            localStorage.removeItem("videotoken");
            if (window && window.Vue && window.Vue.prototype && window.Vue.prototype.$message) {
              window.Vue.prototype.$message.error('登录已过期，请重新登录');
            } else {
              alert('登录已过期，请重新登录');
            }
            router.push('/login').catch(() => {
              window.location.href = '/login'
            })
            setTimeout(() => { is401Handled = false }, 2000)
          }
          return Promise.resolve();
        case 403:
          console.error('权限不足');
          break;
        case 404:
          console.error('请求资源不存在');
          break;
        default:
          console.error(`其他错误状态码: ${error.response.status}`);
      }
    } else if (error.request) {
      console.error('请求已发送，但没有收到响应');
    } else {
      console.error('请求设置发生错误:', error.message);
    }
    return Promise.reject(error);
  }
)

export default request
